import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import CheckboxComponent from 'components/atoms/CheckboxComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import SimpleListComponent from 'components/atoms/SimpleListComponent';
import Title from 'components/atoms/Title';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';
import ObchodniPodminky from 'components/pages/nezarazenyUcet/ObchodniPodminky';
import emailValidation from 'enums/validations/emailValidation';
import React, { useContext, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { IZadostDataNU, nuObjednatApi } from 'services/nezarazenyUcet/nuDedictvi';
import formatNumber from 'utils/formatNumber';
import getLanguageObject from 'utils/getLanguageObject';
import pscValidation from 'utils/validations/pscValidation';
import rodneCisloValidation from 'utils/validations/rodneCisloValidation';
// import VypisKontaktniUdaje from '../VypisKontaktniUdaje';
import OBJED from './OBJED';

interface IIDEN {
    zadostData?: IZadostDataNU;
    contactInfoEmail?: string;
    contactInfoPhone?: string;
    setZadostData?: React.Dispatch<React.SetStateAction<IZadostDataNU | undefined>>;
    setContactInfoEmail?: React.Dispatch<React.SetStateAction<string | undefined>>;
}

const IDEN: React.FC<IIDEN> = props => {
    const [form] = useForm();
    const { language } = useContext(Context);
    const { zadostData, contactInfoEmail, contactInfoPhone, setZadostData, setContactInfoEmail } = props;
    const history = useHistory();
    const [errStatus, setErrStatus] = useState<number>();
    const [stav, setStav] = useState<boolean>(false);
    const [showTerms, setShowTerms] = useState<boolean>(false);
    const { token } = useParams<{ token: string }>();

    const routeChange = () => {
        let path = zadostData?.idzadosti
            ? '/nezarazeny-ucet-dedictvo/bankid/' + zadostData.idzadosti
            : '/nezarazeny-ucet-dedictvo/bankid';
        history.push(path);
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        zadostData?.idzadosti
            ? nuObjednatApi(token, {
                  idzadosti: zadostData?.idzadosti,
                  email: fieldsValue.email,
                  telefon: fieldsValue.telefon.split(' ').join(''),
                  rodnecislo: fieldsValue.rodnecislo,
                  cjdedictvi: fieldsValue.cjdedictvi,
                  ulice: fieldsValue.ulice,
                  mesto: fieldsValue.mesto,
                  psc: fieldsValue.psc
              })
                  .then(() => {
                      setContactInfoEmail
                          ? setContactInfoEmail(fieldsValue.email)
                          : setZadostData &&
                            setZadostData(pv =>
                                pv
                                    ? {
                                          ...pv,
                                          idzadosti: zadostData?.idzadosti,
                                          email: fieldsValue.email,
                                          telefon: fieldsValue.telefon.split(' ').join(''),
                                          rodnecislo: fieldsValue.rodnecislo,
                                          cjdedictvi: fieldsValue.cjdedictvi,
                                          ulice: fieldsValue.ulice,
                                          mesto: fieldsValue.mesto,
                                          psc: fieldsValue.psc
                                      }
                                    : undefined
                            );
                      setStav(true);
                  })
                  .catch((err: AxiosError) => {
                      setErrStatus(err.response?.status);
                  })
            : {};
    };

    return (
        <>
            {errStatus ? (
                <Col span={24}>
                    <Row>
                        {errStatus === 400 ? (
                            <Title text="RESPONSE_ERROR_400" level={3} />
                        ) : errStatus === 401 ? (
                            <Title text="RESPONSE_ERROR_401" level={3} />
                        ) : errStatus === 404 ? (
                            <Title text="RESPONSE_ERROR_404" level={3} />
                        ) : errStatus === 500 ? (
                            <Title text="RESPONSE_ERROR_500" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Row>

                    <Row className="statement-buttons-row">
                        <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChange} />
                    </Row>
                </Col>
            ) : stav ? (
                <>
                    {stav === true ? (
                        <OBJED
                            zadostData={zadostData}
                            contactInfoEmail={contactInfoEmail}
                            contactInfoPhone={contactInfoPhone}
                        />
                    ) : null}
                </>
            ) : showTerms ? (
                <>
                    <ObchodniPodminky setShowTerms={setShowTerms} />
                </>
            ) : (
                <>
                    {/* <Paragraph text="KROKY_PRO_ZISKANI_VYSTUPU" strong={true} /> */}
                    <h3>
                        <TranslateText>KROKY_PRO_ZISKANI_VYSTUPU_NU</TranslateText>
                    </h3>
                    <div
                        className="section-kroky-pro-ziskany-vystupu"
                        style={{
                            marginBottom: 16
                        }}
                    >
                        <Col offset={1} span={23}>
                            <SimpleListComponent
                                data={[
                                    'NU_PODMINKY_1',
                                    'NU_PODMINKY_2',
                                    'NU_PODMINKY_3',
                                    'NU_PODMINKY_4',
                                    'NU_PODMINKY_5',
                                    'NU_PODMINKY_6'
                                ]}
                            />
                        </Col>
                    </div>

                    <h3>
                        <TranslateText>ZADOST_O_SLUZBU_K_AKTUALNIMU_DATU</TranslateText>
                    </h3>
                    <FormWrapper
                        onFinish={onFinish}
                        requiredMark={false}
                        colon={false}
                        outForm={form}
                        labelAlign="left"
                        layoutPosition="horizontal"
                    >
                        {/* <Paragraph
                            text="ZADOST_O_SLUZBU_K_AKTUALNIMU_DATU"
                            strong={true}
                            style={{
                                marginBottom: 4,
                                display: 'block'
                            }}
                        /> */}
                        <InputComponent
                            label="JMENO_PRIJMENI"
                            notRequired={true}
                            name="name"
                            disabled={true}
                            initialValue={`${zadostData?.jmeno ? zadostData.jmeno : '-'} ${
                                zadostData?.prijmeni ? zadostData.prijmeni : '-'
                            }`}
                        />

                        <InputComponent
                            label="TELEFON_ZADATELE"
                            notRequired={true}
                            name="telefon"
                            disabled={true}
                            initialValue={
                                zadostData?.telefon ? formatNumber(zadostData.telefon) : formatNumber(contactInfoPhone)
                            }
                        />
                        <InputComponent
                            label="FORMA_UHRADY1"
                            notRequired={true}
                            name="formauhrady"
                            disabled={true}
                            initialValue={getLanguageObject(language).FORMA_UHRADY2}
                        />
                        <InputComponent
                            label="EMAIL_ZADATELE"
                            name="email"
                            rules={emailValidation('NEVALIDNI_POVINNA_POLOZKA')}
                            initialValue={zadostData?.email ? zadostData.email : contactInfoEmail ?? contactInfoEmail!}
                        />
                        <InputComponent
                            label="RC_ZADATELE"
                            name="rodnecislo"
                            maxLength={10}
                            rules={rodneCisloValidation('NEVALIDNI_POVINNA_POLOZKA')}
                            initialValue={zadostData?.rodnecislo}
                        />
                        <InputComponent
                            className="label-long"
                            label="SPISOVA_ZNACKA"
                            name="cjdedictvi"
                            initialValue={zadostData?.cjdedictvi}
                        />

                        <Paragraph
                            text="ADRESA_FAKTURACANI"
                            style={{
                                marginTop: 6,
                                display: 'block',
                                fontWeight: 700
                            }}
                        />
                        <InputComponent label="ULICE_CP" name="ulice" initialValue={zadostData?.ulice} />
                        <InputComponent label="MESTO" name="mesto" initialValue={zadostData?.mesto} />
                        <InputComponent label="PSC" name="psc" initialValue={zadostData?.psc} rules={pscValidation()} />
                        <Paragraph
                            text="VYPIS_TEXT_MAIL"
                            style={{
                                marginTop: 6,
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="VYPIS_MAIL_INFO"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Row>
                            <CheckboxComponent
                                name="souhlas"
                                checkboxText={
                                    <>
                                        <TranslateText>SOUHLASIM_S</TranslateText>{' '}
                                        <a
                                            onClick={() => {
                                                const fieldsValue = form.getFieldsValue();
                                                setZadostData &&
                                                    setZadostData(pv => {
                                                        return {
                                                            ...pv,
                                                            email: fieldsValue.email,
                                                            telefon: fieldsValue.telefon.split(' ').join(''),
                                                            rodnecislo: fieldsValue.rodnecislo,
                                                            cjdedictvi: fieldsValue.cjdedictvi,
                                                            ulice: fieldsValue.ulice,
                                                            mesto: fieldsValue.mesto,
                                                            psc: fieldsValue.psc
                                                        };
                                                    });
                                                setShowTerms(true);
                                            }}
                                            style={{
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            <TranslateText>PODMINKAMI_SLUZBY</TranslateText>
                                        </a>{' '}
                                        <TranslateText>ZJISTENI_PODMINKA</TranslateText>
                                    </>
                                }
                            />
                        </Row>

                        <Row className="statement-buttons-row">
                            <ButtonComponent htmlType="submit" buttontext="POTVRDIT_A_ODESLAT" />
                        </Row>
                    </FormWrapper>
                </>
            )}
        </>
    );
};

export default IDEN;
